module.exports = __webpack_public_path__ + "img/g2.91e9c099.jpg";